import * as React from "react";
import Row from "../../layout/Row";
import Col from "../../layout/Col";

const classNames = require('classnames');

interface ComponentProps {
	/**
	 * Variant for buttons positioning.
	 */
	align?: "left" | "right"
}

type Props = ComponentProps

/**
 * Wrapper for form buttons.
 */
export default class FormButtonsView extends React.PureComponent<Props, {}> {
	public static defaultProps: Partial<Props> = {
		align: "left"
	};

	render() {
		const classes = classNames({
			"c-form-buttons-view": true,
			[`${this.props.align}`]: this.props.align
		});

		return (
			<Row>
				<Col>
					<div className={classes}>
						{this.props.children}
					</div>
				</Col>
			</Row>
		);
	}
}